<button [class]="color" (click)="handleClick()">
  <i-tabler *ngIf="icon" [name]="icon"></i-tabler>
  {{text}}
</button> 